<template>
    <div :class="classString" class="tooglefilterbox mb-4">
        <input type="checkbox" name="checkboxFilterCases" id="checkboxFilterCases">
        <label for="checkboxFilterCases" class="label-filter-cases optum-bold"><b-icon-chevron-up class="icon-chevron-up mr-2"/>{{title}}</label>
        <b-form class="tooglefilterbox-form row m-0 p-3"> 
            <slot />

            <div class="col-md-12 p-0 d-flex justify-content-end">
                <b-button pill class="btn-base outline-primary-btn mr-4 optum-bold" @click="resetFilter" v-if="isFilter">Limpar Filtros</b-button>
                <b-button pill class="btn-base primary-btn" @click="filter" v-if="isFilter">Filtrar</b-button> 
            </div>            
        </b-form>
    </div> 
</template>

<script>

export default {
    props :{
        isFilter: Boolean,
        title: String,
        classString: String
    },
    methods: {
        filter() {
            this.$emit("filter")   
		},
        resetFilter() {
            this.$emit("resetFilter")   
        },
    }
}

</script>

<style lang="scss" scoped>
.tooglefilterbox{
    border: 1px solid #D1D1D1;
    border-radius: 10px;
}

#checkboxFilterCases{
    display: none;
}

input, select{
    font-size: 14px !important;
}

html body #checkboxFilterCases:checked ~ .tooglefilterbox-form{
    height: 0px;
    padding: 0px !important;
    overflow: hidden;
}

.icon-chevron-up{
    margin-left: 10px;
    transition: 0.2s;
    font-size: 14px !important;
}

#checkboxFilterCases:checked ~ label{
    transition-delay: 0.2s;
}

#checkboxFilterCases:checked ~ label .icon-chevron-up{
    transform: rotate(180deg);
}

.label-filter-cases {
    width: 100%;
    height: auto;
    padding: 5px 0px !important;
    color: $primaryBgColor !important;    
    background-color: $screenSecundaryBgColor;
    display: flex;
    align-items: center;
    justify-content: initial;
    font-size: 16px !important;
    transition: 0.2s;
}

.label-filter-cases:hover {
    cursor: pointer;
    background-color: #9d9fa0;
}

.form-filter-cases {
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    justify-content: flex-end;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.btn-filter-cases{
    margin: 0px 10px 10px 10px;
}

@media (max-width: 930px){
    .label-filter-cases{
        border-radius: 0px;
    }

    #checkboxFilterCases:checked ~ label{
        border-radius: 0px;
    }

    .listing-cases{
        border-radius: 0px;
    }
}
</style>
